import { EditcontrolledareaterminalComponent } from "src/app/features/parking/accesscontrol/controlledareas/edit/editcontrolledareaterminal/editcontrolledareaterminal.component";
import { LevelEditorComponent } from "../../leveleditor.component";
import { PointMapComponent } from "./PointMapComponent";

export class Controller extends PointMapComponent{
    public override ClassName: string = "Controller";
    public override ImageUrl: string = "/assets/leveleditor/terminal.png"
    public override ImageScale = 0.05;
    public override RequiresParent: boolean = true;
    public override ParentClassName: string = "Lane";
    public override ParentLinkId: string = "LocalControllerId";

    constructor(leveleditorcomponent: LevelEditorComponent, canvas: any, formItem: any, parentFormItem: any, forceClone: boolean = false) {
        super(leveleditorcomponent, canvas, formItem, parentFormItem, forceClone);
        this.AddFabricItem();
    }

    public override Clone(formitem: any){
        return new Controller(this.leveleditorcomponent, this.canvas, formitem, this.parentFormItem, true);
    }

    public override ShowModal(): void {
        this.leveleditorcomponent.modalService.addModal(EditcontrolledareaterminalComponent, { Form: this.formItem })
        .subscribe((result) => {
        });
    }
}
